"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatedAtColumn = void 0;
const Cell_1 = require("../Cell");
const constant_1 = require("../constant");
exports.UpdatedAtColumn = {
    Cell: Cell_1.Cell.DateTime,
    accessor: 'updated_at',
    alignment: constant_1.HorizontalAlignment.Left,
    name: 'Updated',
    max: 50,
};
